import React from 'react';
import { AlertDialog } from '../../../../../core/components/dialogs/alertDialog';
import { Paragraph, StackedColumn } from '../../../../../core';

interface NoAppointmentTypesAlertDialogProps {
  onDismiss: () => void;
  isOpen: boolean;
}

const NoAppointmentTypesAlertDialog: React.FC<
  NoAppointmentTypesAlertDialogProps
> = (props: NoAppointmentTypesAlertDialogProps) => {
  return (
    <AlertDialog
      title="No Matches Found"
      isOpen={props.isOpen}
      buttonCaption="Choose a new doctor"
      onDismiss={() => props.onDismiss()}
      maxWidth={350}
    >
      <StackedColumn>
        <Paragraph text="This doctor does not have any available appointments for your age group." />
        <Paragraph text="Please select a different doctor by clicking the button below. You will be taken back to the Find a Doctor page, where you can search for another doctor." />
      </StackedColumn>
    </AlertDialog>
  );
};

export default NoAppointmentTypesAlertDialog;
